module.exports = __webpack_public_path__ + "static/media/home-logitrack.a19c1639.jpg";